import { useCreateOrganizationMember } from 'api/OrganizationAPI';
import { selectIsOrgAdmin } from 'core/userContext';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { ApiError, ErrorHttpResponse } from 'services/api';
import {
  CreateMemberFormSchema,
  createMemberPayload,
  MemberFormProvider,
} from '../../contexts/MemberFormProvider';
import { useOrganizationMembersQueryContext } from '../../contexts/OrganizationMembersQueryContext';
import { useOrganizationModalsContext } from '../../contexts/OrganizationModalsContext';
import { Member } from '../../types';
import { fullName } from '../../utils';
import { MemberModal } from './MemberModal';

export const NewMemberModal = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isOrgAdmin = useSelector(selectIsOrgAdmin);
  const { hideModal } = useOrganizationModalsContext();
  const { refetchAll } = useOrganizationMembersQueryContext();

  const { mutate, isLoading } = useCreateOrganizationMember({
    onSuccess: (member: Member) => {
      refetchAll();
      dispatch(addPositiveToast(`${fullName(member)} was created successfully.`));
      setTimeout(() => {
        history.push(`/members/${member.userId}`);
      }, 1000);
      hideModal();
    },
    onError: (error: ApiError<ErrorHttpResponse>) => {
      const errorMessage = error?.response?.data?.message;
      const msg = errorMessage || 'There was an error creating the member. Please try again.';
      dispatch(addNegativeToastWithErrorId(msg, 'createMember', error));
    },
  });

  const onSubmit = (values: CreateMemberFormSchema) => {
    const payload = createMemberPayload(values);
    mutate(payload as Member);
  };

  return (
    <MemberFormProvider>
      <MemberModal
        id="new-member-modal"
        headerText="New member"
        confirmBtnText="Create member"
        onSubmit={onSubmit}
        isLoading={isLoading}
        includeRoleAndPermissionsFields={isOrgAdmin}
      />
    </MemberFormProvider>
  );
};
